import g from "./globals";

const at = (...predicates) => {
  const includes = [];
  const excludes = [];
  for (const predicate of predicates) {
    if (/!/.test(predicate)) {
      excludes.push(predicate.substring(1));
    } else {
      includes.push(predicate);
    }
  }

  for (const predicate of excludes) {
    if ([g.countryCode, g.locale, g.langCode].indexOf(predicate) !== -1) {
      return false;
    }
  }

  for (const predicate of includes) {
    if ([g.countryCode, g.locale, g.langCode].indexOf(predicate) !== -1) {
      return true;
    }
  }

  return Boolean(excludes.length);
};

export default at;
